export default "__VITE_ASSET__e646848b__"